<template>
    <div>
        <main>
            <section class="bg-dark position-relative overflow-hidden pt-xl-8" data-bs-theme="dark">
                <div class="position-absolute bottom-0 end-0 mb-n9">
                    <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" class="opacity-2 blur-9" alt="Grad shape">
                </div>
    
                <div class="container position-relative text-center pt-4 pt-sm-5">
                    <span class="h2">👋</span>
                    <h1 class="display-5 mt-3">Login to Your Account</h1>
                </div>
            </section>
    
            <section class="pt-0 mt-n6 mt-lg-n7 mt-xl-n8">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <div class="card bg-secondary rounded-4 p-4">
                                <div class="card-body p-0">
                                    <form @submit.prevent="loginUser">
                                        <div class="mb-3">
                                            <label for="email" class="form-label">Email</label>
                                            <input type="email" id="email" v-model="email" class="form-control" required />
                                        </div>
                                        <div class="mb-3 position-relative">
                                            <label for="password" class="form-label">Password</label>
                                            <div class="input-group">
                                                <input :type="showPassword ? 'text' : 'password'" id="password" v-model="password" class="form-control" required />
                                                <span class="input-group-text" @click="togglePasswordVisibility" style="cursor: pointer;">
                                                    <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div v-if="errorMessage" class="text-danger mb-3">
                                            {{ errorMessage }}
                                        </div>
                                        <button type="submit" class="btn btn-primary w-100">Login</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </div>
    </template>
    
    <script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import axios from '../api/axios.js'
    import { ref } from 'vue'
    
    export default {
        components: {
            Header,
            Footer
        },
        setup() {
            const email = ref('')
            const password = ref('')
            const errorMessage = ref(null)
            const showPassword = ref(false)
    
            // Function to handle login
            const loginUser = async () => {
                try {
                    const response = await axios.post('/login', {
                        email: email.value,
                        password: password.value
                    })
                    sessionStorage.setItem('token', response.data.token);
                    sessionStorage.setItem('user', JSON.stringify(response.data.user));
                    window.location.href = '/dashboard/espace'
                } catch (error) {
                    errorMessage.value = 'Invalid credentials or server error.'
                }
            }
    
            // Toggle Password Visibility
            const togglePasswordVisibility = () => {
                showPassword.value = !showPassword.value
            }
    
            return {
                email,
                password,
                errorMessage,
                showPassword,
                loginUser,
                togglePasswordVisibility
            }
        }
    }
    </script>
    
    <style scoped>
    .input-group-text {
        cursor: pointer;
    }
    </style>
    